import {FC, useState} from 'react';
//formik
import {Field, useFormikContext} from 'formik';
//mui
import {Box, IconButton, InputAdornment, Link} from '@mui/material';
//constants
import {END, FIELD, FIELD_LABEL, PASSWORD, PLACEHOLDER, PRIMARY, SIGN_UP, TEXT} from '@/utils/constants';
//icons
import {ReactComponent as EyeSlashIcon} from '@/assets/icons/eye-slash.svg';
import {ReactComponent as EyeIcon} from '@/assets/icons/eye.svg';
//components
import Button from '@/shared/components/Button';
import Input from '@/shared/components/Inputs/Input';
import Checkbox from '@/shared/components/Checkbox';
//helpers
import {setRequiredLabel} from '@/utils/helpers';
//styles
import {formContentStyle} from './FormContent.styles';
import {CreateAccountFormValues} from '../formConfiguration';
import { ROUTER_URL } from '@/utils/enums';

const FormContent: FC = () => {

	const {submitForm} = useFormikContext<CreateAccountFormValues>();

	const onSubmitClickHandler = () => submitForm();

	const [showPassword, setShowPassword] = useState(false);

	const handleClickShowPassword = () => setShowPassword((show) => !show);

	const privacyPolicyTitle = (
		<Box sx={formContentStyle.privacy}>
			I accept the <Link href={ROUTER_URL.ORGANIZATION_TERMS_AND_CONDITIONS}>Terms of Use</Link> and the <Link href={ROUTER_URL.ORGANIZATION_PRIVACY_POLICY}>Privacy Policy</Link>
		</Box>
	);

	return (
		<Box component="form" sx={formContentStyle.form}>
			<Field
				id={FIELD.firstName}
				name={FIELD.firstName}
				placeholder={PLACEHOLDER.firstName}
				label={setRequiredLabel(FIELD_LABEL.firstName)}
				component={Input}
			/>

			<Field
				id={FIELD.lastName}
				name={FIELD.lastName}
				placeholder={PLACEHOLDER.lastName}
				label={setRequiredLabel(FIELD_LABEL.lastName)}
				component={Input}
			/>

			<Field
				id={FIELD.email}
				name={FIELD.email}
				placeholder={PLACEHOLDER.email}
				label={setRequiredLabel(FIELD_LABEL.email)}
				component={Input}
			/>

			<Field
				id={FIELD.password}
				name={FIELD.password}
				placeholder={PLACEHOLDER.password}
				label={setRequiredLabel(FIELD_LABEL.password)}
				component={Input}
				type={showPassword ? TEXT : PASSWORD}
				sx={formContentStyle.passwordIcon}
				InputProps={{
					endAdornment: (
						<InputAdornment position={END}>
							<IconButton onClick={handleClickShowPassword} edge={END}>
								{showPassword ? <EyeIcon /> : <EyeSlashIcon />}
							</IconButton>
						</InputAdornment>
					),
				}}
			/>

			<Field
				id={FIELD.checkbox}
				name={FIELD.checkbox}
				color={PRIMARY}
				label={privacyPolicyTitle}
				component={Checkbox}
				sx={formContentStyle.checkbox}
			/>

			<Button onClick={onSubmitClickHandler} title={SIGN_UP} />
		</Box>
	);
};

export default FormContent;
